import script from "./CallTypeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CallTypeIcon.vue?vue&type=script&setup=true&lang=js"

import "./CallTypeIcon.vue?vue&type=style&index=0&id=763ccc3e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763ccc3e"]])

export default __exports__